import ContactUsForm from "./contact-us-form/contact-us-form"
import "./contact-us.scss" ;
import {ReactComponent as MapPinIcon } from "../../assets/icons/map-pin.svg" ;
import Navbar from "../common/navbar/navbar";
import { CHOOSE_PLAN_ROUTE } from "../../routes";
import FooterSection from "../common/footer/footer";
import { useEffect } from "react";

const ContactUs = ({history}) => {

    // style variables
    let navHeight = "7.25rem" ;

    useEffect(()=>{ 
        window.scrollTo({
            top: 0
        });
    },[])

    // links for top navbar
    const navLinks = [
        <h5 key="0" className="my-0 mx-3 text-1" style={{cursor:"pointer"}} onClick={()=>{history.push("/#how-it-works-section")}} >How it Works</h5>,
        <h5 key="1" className="my-0 mx-3 text-1" style={{cursor:"pointer"}} onClick={()=>{history.push("/#company")}} >Company</h5>,
        <h5 key="2" className="my-0 mx-3 text-1" style={{cursor:"pointer"}} onClick={()=>{history.push("/#pricing")}} >Pricing</h5>,
        <h5 key="3" className="my-0 mx-3 text-1" style={{cursor:"pointer"}} onClick={()=>{history.push("/contact-us")}} >Contact Us</h5>,
    ];

    // links for sidebar
    const sidebarLinks = [
        <h5 key="0" className="my-0 mx-3 text-1" data-bs-dismiss="offcanvas" style={{cursor:"pointer"}} onClick={()=>{history.push("/#how-it-works-section")}}>How it Works</h5>,
        <h5 key="1" className="my-0 mx-3 text-1" data-bs-dismiss="offcanvas" style={{cursor:"pointer"}} onClick={()=>{history.push("/#company")}}>Company</h5>,
        <h5 key="2" className="my-0 mx-3 text-1" data-bs-dismiss="offcanvas" style={{cursor:"pointer"}} onClick={()=>{history.push("/#pricing")}}>Pricing</h5>,
        <h5 key="3" className="my-0 mx-3 text-1" data-bs-dismiss="offcanvas" style={{cursor:"pointer"}} onClick={()=>{history.push("/contact-us")}}>Contact Us</h5>,
    ];

    // links for footer
    const footerLinks = [
        <h5 key="0" className="my-3 text-inverse" style={{cursor:"pointer"}} onClick={()=>{history.push("/#how-it-works-section")}} >How it Works</h5>,
        <h5 key="1" className="my-3 text-inverse" style={{cursor:"pointer"}} onClick={()=>{history.push("/#company")}} >Company</h5>,
        <h5 key="2" className="my-3 text-inverse" style={{cursor:"pointer"}} onClick={()=>{history.push("/#pricing")}} >Pricing</h5>,
        <h5 key="3" className="my-3 text-inverse" style={{cursor:"pointer"}} onClick={()=>{history.push("/contact-us")}} >Contact Us</h5>,
    ];

    // action buttons for top navbar
    const navButtons = [
        <button style={{height:"3rem"}} onClick={()=>{history.push("/#free-alerts")}} className="btn btn-outline-primary rounded-pill text-nowrap px-5 text-btn">Free Alerts</button>,
        <button style={{height:"3rem"}} onClick={()=>history.push(CHOOSE_PLAN_ROUTE)} className="btn btn-primary rounded-pill text-nowrap text-inverse px-5 text-btn">Get Started</button>
    ];

    // action buttons for sidebar
    const sidebarButtons = [
        <button style={{height:"3rem"}} onClick={()=>{history.push("/#free-alerts")}} className="btn btn-outline-primary rounded-pill text-nowrap px-5 text-btn">Free Alerts</button>,
        <button style={{height:"3rem"}} onClick={()=>history.push(CHOOSE_PLAN_ROUTE)} className="btn btn-primary rounded-pill text-nowrap text-inverse px-5 text-btn">Get Started</button>
    ];



    return ( 
        <>
        <Navbar navHeight={navHeight} navButtons={navButtons} navLinks={navLinks} sidebarButtons={sidebarButtons} sidebarLinks={sidebarLinks} />
        <main className="w-100" style={{ marginTop: navHeight , overflowY : "hidden"}}>
            <div id="contact-us" className="bg-light py-5" style={{ minHeight: `calc(100vh - ${navHeight})` }}>
                <div className="container-sm p-0 mt-4">
                    <div className="content">
                        <div className="text flex-fill">
                            <h1 className="text-secondary">
                                Contact Us
                            </h1>
                            <div className="mt-5">
                                <h4 className="text-2">Phone</h4>
                                <div className="text-body-1 text-2">
                                    +61 02 8324 1407
                                </div>
                            </div>
                            <div className="mt-5">
                                <h4 className="text-2">Location</h4>
                                <h5 className="text-2">
                                    {/* <MapPinIcon stroke="var(--primary)" /> */}
                                    iComply
                                </h5>
                                <div className="text-body-1 text-2">
                                    WTL Building Level 4 <br/>    
                                    Suite 408/83 York Street, Sydney <br/>  
                                    NSW 2000
                                </div>
                            </div>
                        </div>
                        <div className="form flex-fill">
                            <ContactUsForm />
                        </div>
                    </div>
                </div>
            </div> 
        </main>
        <FooterSection links={footerLinks} />
        </>
    );
}
 
export default ContactUs;